import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathGreaterThan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMathGreaterThan"><Path fillRule="evenodd" clipRule="evenodd" d="M5.34892 5.76855L20.1868 12.0005L5.34892 18.2324L4.76807 16.8494L16.3132 12.0005L4.76807 7.15153L5.34892 5.76855Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMathGreaterThan;
